import { useTranslate } from '@tolgee/react';
import { BaseSysMsgProps } from './types';
import { SystemMessage } from 'components/Dialogue';
import dayjs from 'lib/dayjs';
import { toNumber } from 'lodash-es';
import { memo } from 'react';

export const SysProcessConversationMsg = memo((props: BaseSysMsgProps) => {
  const { raw } = props;
  const { sysProcessConversationContent: { assistantName, timestamp } = {} } = raw;
  const { t } = useTranslate();

  if (assistantName || timestamp) {
    return (
      <SystemMessage>
        {t('scene.chatWorkspace.messageThread.systemMessage.markedAsProcessed', {
          who: assistantName,
          time: dayjs(toNumber(timestamp)).format('MM-DD HH:mm:ss'),
        })}
      </SystemMessage>
    );
  }

  return null;
});
